// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__tGFvw","notes":"Notes_notes__eyceB","note":"Notes_note__I1nsi","markdown":"Notes_markdown__3s4LE"};